export const HOME = {
  emergentLink: "home-emergent-link",
  hero: "home-hero",
  heroDownloadApple: "hero-download-apple",
  heroDownloadGoogle: "hero-download-google",
  heroStartFree: "hero-start-free",
  navStartFree: "nav-start-free",
  navLogo: "nav-logo",
  langSwitcher: "lang-switcher",
  mobileMenuTrigger: "mobile-menu-trigger",
  faithToggle: "faith-toggle",
  funnelStartFree: "funnel-start-free",
  funnelDownloadApple: "funnel-download-apple",
  funnelDownloadGoogle: "funnel-download-google",
  faqAccordion: "faq-accordion",
  useCaseFilter: "use-case-filter",
};
